function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  d: "M32.089,0.74h31.054  c17.339,0,31.395,14.055,31.395,31.395v31.054c0,17.34-14.056,31.396-31.395,31.396H32.089c-17.339,0-31.396-14.056-31.396-31.396  V32.135C0.693,14.795,14.75,0.74,32.089,0.74L32.089,0.74z"
});

var _ref2 = /*#__PURE__*/React.createElement("polygon", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "47.616,22.4 65.477,29.8 72.875,47.662   65.477,65.522 47.616,72.922 29.753,65.522 22.355,47.662 29.753,29.8 "
});

var _ref3 = /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "0.693,47.832 14.344,34.865   22.192,47.832 "
});

var _ref4 = /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "0.864,28.381 14.344,34.865   29.871,29.916 "
});

var _ref5 = /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "29.7,29.746 34.819,14.731   10.59,9.271 14.344,34.865 "
});

var _ref6 = /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "47.616,22.409 34.989,14.901   27.994,0.91 "
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  x1: 47.616,
  y1: 0.74,
  x2: 34.989,
  y2: 14.901
});

var _ref8 = /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "94.538,47.832 80.887,34.865   73.04,47.832 "
});

var _ref9 = /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "94.368,28.381 80.887,34.865   65.361,29.916 "
});

var _ref10 = /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "65.532,29.746 60.413,14.731   84.641,9.271 80.887,34.865 "
});

var _ref11 = /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "47.616,22.409 60.243,14.901   67.238,0.91 "
});

var _ref12 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  x1: 47.616,
  y1: 0.74,
  x2: 60.243,
  y2: 14.901
});

var _ref13 = /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "94.538,47.491 80.887,60.458   73.04,47.491 "
});

var _ref14 = /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "94.368,66.942 80.887,60.458   65.361,65.407 "
});

var _ref15 = /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "65.532,65.577 60.413,80.592   84.641,86.054 80.887,60.458 "
});

var _ref16 = /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "47.616,72.914 60.243,80.422   67.238,94.413 "
});

var _ref17 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  x1: 47.616,
  y1: 94.583,
  x2: 60.243,
  y2: 80.422
});

var _ref18 = /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "0.693,47.491 14.344,60.458   22.192,47.491 "
});

var _ref19 = /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "0.864,66.942 14.344,60.458   29.871,65.407 "
});

var _ref20 = /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "29.7,65.577 34.819,80.592   10.59,86.054 14.344,60.458 "
});

var _ref21 = /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "47.616,72.914 34.989,80.422   27.994,94.413 "
});

var _ref22 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  x1: 47.616,
  y1: 94.583,
  x2: 34.989,
  y2: 80.422
});

const SvgCushion = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Foreground",
  x: "0px",
  y: "0px",
  width: "95.333px",
  height: "95.334px",
  viewBox: "0 0 95.333 95.334",
  enableBackground: "new 0 0 95.333 95.334",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCushion, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cushion.b534e6ea.svg";
export { ForwardRef as ReactComponent };